// libs
import React from "react";
import { Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import moment from "moment";
// actions
import { ROUTERS } from "../../../constants/routers.js";
import { LOCAL_STORAGE } from "../../../constants/localStorageConstants";
// configs
import { AXIOS_INSTANCE } from "../../../config.js";

const { SELECTED_BRANCH } = LOCAL_STORAGE;

export function checkUserShiftTypes(history, t, today = false) {
  return (dispatch) => {
    return AXIOS_INSTANCE.request({
      url: `/api/${
        JSON.parse(localStorage.getItem(SELECTED_BRANCH))["code"]
      }/userShiftTypes/check`,
      method: "get",
      params: {
        fromDate: today
          ? moment.utc().startOf("day").toISOString()
          : moment().startOf("month").toISOString(),
        toDate: today
          ? moment.utc().endOf("day").toISOString()
          : moment().endOf("month").toISOString(),
      },
    })
      .then((res) => {
        if (res.data) {
          Modal.confirm({
            centered: true,
            title: t("t_warning"),
            content: res.data,
            icon: <ExclamationCircleOutlined />,
            okText: t("t_go_to_calendar"),
            cancelText: t("t_cancel"),
            onOk() {
              history.push(ROUTERS.CALENDAR);
            },
          });
        }
      })
      .catch((err) => {});
  };
}
